module.exports = __webpack_public_path__ + "static/media/honda-minus.3a30b141.svg";